export const XSTOCK_MIN_TRADE_SIZE_USD = 10
